var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSizemdPaymentmethodPayPal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4858 24.5977L19.7801 22.6655L19.1245 22.6497H15.9939L18.1695 8.39157C18.1763 8.3484 18.1982 8.30832 18.2302 8.27981C18.2624 8.25129 18.3034 8.23565 18.3462 8.23565H23.6249C25.3774 8.23565 26.5868 8.6125 27.2181 9.35642C27.5142 9.70541 27.7027 10.0702 27.7939 10.4715C27.8896 10.8927 27.8912 11.3958 27.7979 12.0095L27.7911 12.0542V12.4475L28.0871 12.6208C28.3364 12.7575 28.5345 12.9139 28.6865 13.093C28.9396 13.3915 29.1034 13.7707 29.1726 14.2203C29.2442 14.6826 29.2205 15.233 29.1034 15.856C28.9683 16.5726 28.75 17.1968 28.4551 17.7074C28.1839 18.1779 27.8384 18.5683 27.4281 18.8707C27.0364 19.1581 26.571 19.3762 26.0449 19.5159C25.5349 19.653 24.9536 19.7223 24.3159 19.7223H23.9052C23.6115 19.7223 23.3262 19.8316 23.1022 20.0276C22.8775 20.2277 22.7291 20.5011 22.6835 20.8L22.6524 20.974L22.1324 24.3797L22.1089 24.5047C22.1026 24.5442 22.0919 24.564 22.0761 24.5773C22.0621 24.5895 22.0419 24.5977 22.0222 24.5977H19.4858Z",
    fill: "#28356A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3675 12.0996C28.3519 12.2037 28.3338 12.3101 28.3136 12.4194C27.6175 16.1136 25.2358 17.3898 22.1942 17.3898H20.6454C20.2734 17.3898 19.9599 17.6689 19.902 18.0482L18.8845 24.7192C18.8468 24.9683 19.0325 25.1926 19.2756 25.1926H22.0225C22.3477 25.1926 22.624 24.9484 22.6753 24.6169L22.7022 24.4727L23.2194 21.0804L23.2527 20.8943C23.3033 20.5616 23.5802 20.3172 23.9054 20.3172H24.3162C26.9775 20.3172 29.061 19.2005 29.6699 15.9687C29.9241 14.6187 29.7925 13.4914 29.1194 12.6986C28.9158 12.4596 28.6631 12.2612 28.3675 12.0996Z",
    fill: "#298FC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.639 11.7995C27.5326 11.7674 27.4229 11.7384 27.3103 11.7122C27.1972 11.6866 27.0813 11.664 26.962 11.6441C26.5444 11.5743 26.0868 11.5413 25.5967 11.5413H21.4593C21.3573 11.5413 21.2606 11.5651 21.174 11.6081C20.9831 11.7029 20.8414 11.8896 20.8071 12.1182L19.9268 17.8802L19.9016 18.0482C19.9595 17.6689 20.273 17.3898 20.645 17.3898H22.1937C25.2354 17.3898 27.6171 16.113 28.3132 12.4194C28.334 12.3101 28.3515 12.2037 28.3671 12.0996C28.191 12.003 28.0003 11.9204 27.7949 11.85C27.7441 11.8326 27.6918 11.8158 27.639 11.7995Z",
    fill: "#22284F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8073 12.1182C20.8417 11.8896 20.9834 11.7029 21.1743 11.6087C21.2615 11.5656 21.3576 11.5418 21.4596 11.5418H25.597C26.0871 11.5418 26.5447 11.575 26.9623 11.6447C27.0816 11.6645 27.1975 11.6873 27.3106 11.7128C27.4232 11.7389 27.5329 11.7681 27.6393 11.8C27.6921 11.8163 27.7444 11.8332 27.7957 11.85C28.0011 11.9204 28.192 12.0037 28.368 12.0996C28.5752 10.7345 28.3663 9.80498 27.6522 8.9633C26.8648 8.03658 25.4439 7.64001 23.6257 7.64001H18.3469C17.9755 7.64001 17.6586 7.91911 17.6013 8.29905L15.4026 22.7038C15.3593 22.9888 15.5719 23.2459 15.85 23.2459H19.1089L20.8073 12.1182Z",
    fill: "#28356A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizemdPaymentmethodPayPal);
export default __webpack_public_path__ + "static/media/Size=md, Payment method=PayPal.2cf108b8.svg";
export { ForwardRef as ReactComponent };